import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { callApi } from '../../../api/call';
import { findCompanyBySlug } from '../../../client-experience/utils/companyAccess';
import '../../styles/LandingPage.css';

/**
 * After Accept Hosted payment; finalizes the pending appointment on Cloud Run.
 */
const StorefrontAuthorizeBookingSuccessPage = () => {
  const { companyUrl, appointmentId } = useParams();
  const [error, setError] = useState(null);
  const [subtitle, setSubtitle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const company = await findCompanyBySlug(companyUrl);
        if (!company?.id) {
          throw new Error('Business not found.');
        }

        const { data } = await callApi(
          `/api/companies/${encodeURIComponent(company.id)}/payments/authorize/finalize`,
          { companyId: company.id, appointmentId },
          { auth: false }
        );
        const pub = data?.appointment?.publicNumber;
        if (!cancelled && pub != null && /^\d+$/.test(String(pub))) {
          setSubtitle(`Appointment #${pub}`);
        }
      } catch (e) {
        console.error('[StorefrontAuthorizeBookingSuccess]', e);
        if (!cancelled) {
          setError(e?.message || 'Something went wrong confirming your booking.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [companyUrl, appointmentId]);

  return (
    <div className="landing-page">
      <div className="container storefront-booking-success">
        <div className="storefront-booking-success__card">
          {loading ? (
            <>
              <h1>Confirming your booking…</h1>
              <p>Please wait a moment.</p>
            </>
          ) : error ? (
            <>
              <h1>Almost there</h1>
              <p>{error}</p>
              <p>If you completed payment, the business still may have received it—contact them with your email.</p>
              <Link to={`/book/${companyUrl}`} className="back-link">
                Back to booking site
              </Link>
            </>
          ) : (
            <>
              <h1>You&apos;re all set</h1>
              {subtitle ? <p className="storefront-booking-success__ref">{subtitle}</p> : null}
              <p>
                Your payment was received. Your appointment details will appear in your confirmation email shortly.
                If anything looks wrong, contact the business directly.
              </p>
              <Link to={`/book/${companyUrl}`} className="back-link">
                Back to booking site
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default StorefrontAuthorizeBookingSuccessPage;
